<form [formGroup]="accountForm" class="checkout-form">

  <div class="pt-6" *ngIf="environment.mockSignup">
    <button type="button" (click)="fillMockData()"
      class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
      Fill MockData
    </button>
  </div>

  <h2>Account</h2>


  <!-- Business -->
  <div>
    <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_company') }}</label>
    <input type="text" formControlName="business"
      class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
    <span class="text-xs text-gray-500">{{ textService.getText('form_description_company') }}</span>
  </div>

  <!-- Domain -->
  <!-- ============================== -->
  <!-- OFFICE 365 DOMAIN UI -->
  <!-- ============================== -->
  <div *ngIf="flow === 'office365'">
    <label class="block text-sm font-medium mb-1">Your Company</label>
  
    <div
      class="relative flex w-full rounded-md border border-gray-300 bg-white overflow-hidden focus-within:ring focus-within:ring-blue-300">
      <input
        type="text"
        formControlName="domain"
        placeholder="yourcompany"
        class="flex-1 px-3 py-2 text-sm focus:outline-none pr-40"
      />
  
      <span
        class="absolute inset-y-0 right-0 flex items-center px-3 bg-gray-200 border-l text-gray-700 rounded-r-md text-sm whitespace-nowrap">
        .onmicrosoft.com
      </span>
  
      <div
        *ngIf="accountForm.get('domain')?.status === 'PENDING'"
        class="absolute inset-y-0 right-36 flex items-center text-gray-500">
        <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"></path>
        </svg>
      </div>
    </div>
  
    <!-- DOMAIN TAKEN -->
    <div *ngIf="accountForm.get('domain')?.errors?.['domainTaken']" class="text-sm text-red-600 mt-1">
      This domain name is already in use.
    </div>
  
    <!-- GENERIC ERRORS -->
    <div *ngIf="accountForm.get('domain')?.touched && accountForm.get('domain')?.errors"
      class="text-sm text-red-600 mt-1">
      <div *ngIf="accountForm.get('domain')?.errors?.['required']">This field is required.</div>
      <div *ngIf="accountForm.get('domain')?.errors?.['domainCheckFailed']">Could not validate tenant.</div>
      <div *ngIf="accountForm.get('domain')?.errors?.['invalidOfficeName']">
        Only 3–27 alphanumeric characters. No dots or TLDs allowed.
      </div>
    </div>
  
    <!-- SUCCESS (NOW SHOWS CORRECTLY) -->
    <div
      *ngIf="
        accountForm.get('domain')?.valid &&
        accountForm.get('domain')?.status !== 'PENDING' &&
        !accountForm.get('domain')?.errors &&
        accountForm.get('domain')?.value &&
        !accountForm.get('domain')?.value.includes('.')
      "
      class="text-green-600 text-sm mt-1 flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2l4-4m5 2a9 9 0 11-18 0a9 9 0 0118 0z" />
      </svg>
      Domain is available
    </div>
  
    <!-- HINT -->
    <div class="text-xs text-gray-600 mt-2">
      Use 3–27 alphanumeric characters. This will be your Office user ID and OneDrive/SharePoint URL.
    </div>
  </div>
  

  <!-- ============================== -->
  <!-- APPS / NON-OFFICE365 UI -->
  <!-- ============================== -->
  <div *ngIf="flow !== 'office365' && flow !== 'reseller'">
    <label class="block text-sm font-medium mb-1">
      {{ textService.getText('form_label_domain_name') }}
    </label>

    <div class="flex relative">
      <span class="px-3 py-2 border border-r-0 rounded-l-md bg-gray-200 text-gray-600">
        http://www.
      </span>

      <input type="text" formControlName="domain"
        class="flex-1 border rounded-r-md px-3 py-2 pr-28 focus:ring focus:ring-blue-300"
        placeholder="yourdomain.com" />

      <!-- LOADING -->
      <div *ngIf="accountForm.get('domain')?.status === 'PENDING'"
        class="absolute inset-y-0 right-2 flex items-center text-gray-500">
        <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"></path>
        </svg>
      </div>

      <!-- SUCCESS (only buy) -->
      <div *ngIf="
        accountForm.get('domain')?.valid &&
        accountForm.get('domain')?.status !== 'PENDING' &&
        accountForm.get('domainOption')?.value === 'buy'
      " class="absolute inset-y-0 right-2 flex items-center text-green-600 text-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2l4-4m5 2a9 9 0 11-18 0a9 9 0 0118 0z" />
        </svg>
        Domain is available
      </div>
    </div>

    <!-- ERRORS -->
    <div *ngIf="accountForm.get('domain')?.touched && accountForm.get('domain')?.errors"
      class="text-sm text-red-600 mt-1">
      <div *ngIf="accountForm.get('domain')?.errors?.['required']">Domain is required.</div>
      <div *ngIf="accountForm.get('domain')?.errors?.['invalidDomain']">
        {{ textService.getText('form_validate_domain_name_invalid') }}
      </div>
      <div *ngIf="accountForm.get('domain')?.errors?.['domainTaken']">This domain is already registered.</div>
      <div *ngIf="accountForm.get('domain')?.errors?.['domainCheckFailed']">Could not verify domain.</div>
    </div>

    <!-- OPTIONS -->
    <div class="space-y-2 mt-2">
      <label class="flex items-center space-x-2">
        <input type="radio" value="own" formControlName="domainOption" />
        <span>{{ textService.getText('dns_type_pointtous') }}</span>
      </label>

      <label class="flex items-center space-x-2">
        <input type="radio" value="buy" formControlName="domainOption" />
        <span>{{ textService.getText('dns_type_new') }}</span>
      </label>
    </div>
  </div>


  <!-- Extra US-only fields -->
  <div *ngIf="accountForm.get('domainOption')?.value === 'buy' && accountForm.get('domain')?.value?.endsWith('.us')"
    class="mt-4 space-y-4">

    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('apps_ext_attrs_nexus') }}</label>
      <select formControlName="usNexus" class="w-full border rounded-md px-3 py-2">
        <option value="">Select one</option>
        <option *ngFor="let o of usNexusOptions" [value]="o.value">{{ o.title }}</option>
      </select>
      <div *ngIf="accountForm.get('usNexus')?.touched && accountForm.get('usNexus')?.errors?.['required']"
        class="text-sm text-red-600 mt-1">
        Nexus Category is required.
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_country') }}</label>
      <select formControlName="usCountry" class="w-full border rounded-md px-3 py-2">
        <option value="">Select a country</option>
        <option *ngFor="let c of usCountryOptions" [value]="c.value">{{ c.title }}</option>
      </select>
      <div *ngIf="accountForm.get('usCountry')?.touched && accountForm.get('usCountry')?.errors?.['required']"
        class="text-sm text-red-600 mt-1">
        Country is required.
      </div>
    </div>

    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('apps_ext_attrs_purpose') }}</label>
      <select formControlName="usPurpose" class="w-full border rounded-md px-3 py-2">
        <option value="">Select purpose</option>
        <option *ngFor="let p of usPurposeOptions" [value]="p.value">{{ p.title }}</option>
      </select>
      <div *ngIf="accountForm.get('usPurpose')?.touched && accountForm.get('usPurpose')?.errors?.['required']"
        class="text-sm text-red-600 mt-1">
        Application Purpose is required.
      </div>
    </div>

  </div>


  <!-- User Info -->
  <h2>User Info</h2>

  <div class="grid grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_first_name') }}</label>
      <input type="text" formControlName="firstName"
        class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
      <div *ngIf="accountForm.get('firstName')?.touched && accountForm.get('firstName')?.errors?.['required']"
        class="text-sm text-red-600 mt-1">{{ textService.getText('form_validate_first_name') }}
      </div>
    </div>
    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_last_name') }}</label>
      <input type="text" formControlName="lastName"
        class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
      <div *ngIf="accountForm.get('lastName')?.touched && accountForm.get('lastName')?.errors?.['required']"
        class="text-sm text-red-600 mt-1">{{ textService.getText('form_validate_last_name') }}
      </div>
    </div>
  </div>

  <!-- Username -->
  <div>
    <label class="block text-sm font-medium mb-1">
      {{ textService.getText('form_label_username') }}
    </label>

    <div class="relative">
      <input type="text" formControlName="username"
        class="w-full border rounded-md px-3 py-2 pr-10 focus:ring focus:ring-blue-300" />

      <div *ngIf="accountForm.get('username')?.pending"
        class="absolute inset-y-0 right-2 flex items-center text-gray-500">
        <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"></path>
        </svg>
      </div>
    </div>

    <span class="text-xs text-gray-500">
      {{ textService.getText('form_description_apps_username') }}
    </span>

    <!-- ERRORS -->
    <div *ngIf="accountForm.get('username')?.invalid
            && (accountForm.get('username')?.dirty || accountForm.get('username')?.touched)"
      class="text-sm text-red-600 mt-1">

      <div *ngIf="accountForm.get('username')?.errors?.['required']">
        {{ textService.getText('form_validate_apps_username_invalid') }}
      </div>

      <!-- CLOUD OFFICE RECHAZÓ USERNAME -->
      <div *ngIf="accountForm.get('username')?.errors?.['cloudOffice']">
        Username is not available in Cloud Office.
      </div>
    </div>
  </div>




  <div class="grid grid-cols-2 gap-4">
    <!-- Password -->
    <div class="relative">
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_cloud_password') }}</label>
      <input [type]="showPassword ? 'text' : 'password'" formControlName="password"
        class="w-full border rounded-md px-3 py-2 pr-10 focus:ring focus:ring-blue-300" />
      <!-- Eye toggle -->
      <button type="button" (click)="showPassword = !showPassword"
        class="absolute right-2 top-8 text-gray-500 hover:text-gray-700">
        <!-- Eye -->
        <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <!-- Eye off -->
        <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.969 
                   9.969 0 012.88-4.419M9.88 9.88a3 3 0 104.24 4.24M6.1 6.1l11.8 11.8" />
        </svg>
      </button>

      <div *ngIf="accountForm.get('password')?.touched && accountForm.get('password')?.errors"
        class="text-sm text-red-600 mt-1">
        <div *ngIf="accountForm.get('password')?.errors?.['required']">{{
          textService.getText('form_validate_cloud_password_confirmation_empty') }}</div>
        <div *ngIf="accountForm.get('password')?.errors?.['strongPassword']">{{
          textService.getText('form_validate_apps_password_invalid') }}

        </div>
      </div>
    </div>

    <!-- Confirm Password -->
    <div class="relative">
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_cloud_password_confirmation')
        }}</label>
      <input [type]="showConfirm ? 'text' : 'password'" formControlName="confirmPassword"
        class="w-full border rounded-md px-3 py-2 pr-10 focus:ring focus:ring-blue-300" />
      <!-- Eye toggle -->
      <button type="button" (click)="showConfirm = !showConfirm"
        class="absolute right-2 top-8 text-gray-500 hover:text-gray-700">
        <!-- Eye -->
        <svg *ngIf="!showConfirm" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
        <!-- Eye off -->
        <svg *ngIf="showConfirm" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.969 
                   9.969 0 012.88-4.419M9.88 9.88a3 3 0 104.24 4.24M6.1 6.1l11.8 11.8" />
        </svg>
      </button>

      <div *ngIf="accountForm.errors?.['passwordMismatch'] && accountForm.get('confirmPassword')?.touched"
        class="text-sm text-red-600 mt-1">{{ textService.getText('form_validate_cloud_password_confirmation_mismatch')
        }}
      </div>
    </div>
  </div>


  <div>
    <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_cloud_security_question')
      }}</label>
    <select formControlName="securityQuestion"
      class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300">
      <option value="" label="- Select your security question -">- Select your security question -</option>
      <option *ngFor="let questions of textService.getText('security_questions')" value="{{ questions }}"
        label="{{ questions }}">{{ questions }}</option>


    </select>
    <div
      *ngIf="accountForm.get('securityQuestion')?.touched && accountForm.get('securityQuestion')?.errors?.['required']"
      class="text-sm text-red-600 mt-1">
      {{ textService.getText('form_validate_cloud_security_question_empty') }}
    </div>
  </div>

  <div>
    <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_cloud_security_answer') }}</label>
    <input type="text" formControlName="securityAnswer"
      class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
    <div *ngIf="accountForm.get('securityAnswer')?.touched && accountForm.get('securityAnswer')?.errors?.['required']"
      class="text-sm text-red-600 mt-1">{{ textService.getText('form_validate_cloud_security_answer_empty') }}
    </div>
  </div>

  <div class="grid grid-cols-2 gap-4">
    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_email') }}</label>
      <input type="email" formControlName="email"
        class="w-full border rounded-md px-3 py-2 focus:ring focus:ring-blue-300" />
      <div *ngIf="accountForm.get('email')?.touched && accountForm.get('email')?.errors"
        class="text-sm text-red-600 mt-1">
        <div *ngIf="accountForm.get('email')?.errors?.['required']">Email is required.</div>
        <div *ngIf="accountForm.get('email')?.errors?.['invalidEmail']">{{ textService.getText('form_validate_email') }}</div>
      </div>
    </div>


    <div>
      <label class="block text-sm font-medium mb-1">{{ textService.getText('form_label_phone') }}</label>
      <app-phone-number-field formControlName="phone"></app-phone-number-field>
    </div>

  </div>
</form>